<template>
  <v-card
    class="Row-card pa-0"
    :class="service.active && `Row-card--active`"
    :disabled="disabled"
    :elevation="service.active ? 10 : null"
    @click="clickCard"
    :ripple="false"
    data-e2e="CardServiceCard"
  >
    <v-icon v-if="service.active" class="Col-icon" :size="small ? '10px' : '40px'" data-e2e="CardServiceActiveIcon"
      >mdi-check-circle</v-icon
    >
    <div class="pa-2 d-flex flex-md-column" v-if="service.value != 'custom'">
      <v-icon :size="small ? '2rem' : '4rem'" class="mb-md-3 mr-5 mr-md-0">{{ service.icon }}</v-icon>
      <div class="Card-text text-center pa-1">
        {{ $t(`onBoarding.stepService.cards.${service.key}.top`) }}
      </div>
      <div class="Card-text text-center pa-1">
        {{ $t(`onBoarding.stepService.cards.${service.key}.bottom`) }}
      </div>
    </div>

    <div class="pa-2 d-flex flex-md-column" v-else>
      <v-icon :size="small ? '2rem' : '4rem'" class="mb-md-3 mr-5 mr-md-0">{{ service.icon }}</v-icon>
      <div class="Card-text text-center pa-1">
        {{ service.name}}
      </div>
    </div>

  </v-card>
</template>

<script>
export default {
  name: 'CardService',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    service: {
      type: Object,
      required: true,
      validator: service => ['icon', 'key', 'active'].every(key => Object.keys(service).includes(key))
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    clickCard() {
      this.$emit('clickCard', this.service)
      this.service.active = !this.service.active
    }
  }
}
</script>

<style scoped lang="scss">
.Col-icon {
  position: absolute;
  right: -20px;
  top: -20px;
  color: var(--v-primary-base);
  background-color: #fff;
  border-radius: 25px !important;
}

.App-nikon .Col-icon, .App-nikon-it .Col-icon {
  position: absolute;
  right: -20px;
  top: -20px;
  color: var(--v-primary-base);
  background-color: #fff;
  border-radius: 25px !important;
}

.Row-card {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--v-secondary-lighten1);
  width: 185px;
  &::before {
    background: none;
  }
  > div {
    display: flex; 
    align-items: center;
    justify-content: center;
    .Card-text {
      font-size: 1.5em;
      color: var(--v-secondary-base);
    }
  }
  &--active {
    border: 1px solid var(--v-secondary-base);
    .Card-text {
      font-weight: 500;
    }
  }
}
</style>
